import React from "react";
import LayoutPosSettings from "../../../../boxes/LayoutPosSettings/LayoutPosSettings";
import { Box } from "../../../../shared/Box/Box";
import classes from "./scss/PosSunbit.module.scss";
import { useSunbitCapabilities } from "./hooks/useSunbitCapabilities";
import Capabilities from "./components/Capabilities";
import { Skeleton } from "../../../../shared/Skeleton/Skeleton";

const PosSunbit = () => {
  const { data, isLoading } = useSunbitCapabilities();
  const isSunbitEnabled = data?.capabilities?.[0]?.is_sunbit_enabled;

  return (
    <LayoutPosSettings activeMenu="pos-sunbit">
      <Box className={classes.sunbitContainer}>
        <h5 className={classes.sunbitTitle}>
          <span>Sunbit Payment Method</span>
          <span>Processing Fee: 5.5%</span>
        </h5>
        <div className={classes.sunbitContent}>
          {!isSunbitEnabled && (
            <p>
              By enabling Sunbit payments, you agree to follow the brand & legal
              advertising guidelines provided by Sunbit and found here: &nbsp;
            </p>
          )}
          <p>
            Sunbit is the preferred buy now, pay-over-time consumer financing
            technology for everyday needs, offering access to fast, fair, and
            transparent payment options to 90% of patients.
            <ul className={classes.sunbitList}>
              <li>90% of patients approved* (no late fees)</li>
              <li>0% APR option presented to all approved patients</li>
              <li>
                Providers are paid upfront and in full no later than 5 business
                days after patient selection
              </li>
            </ul>
          </p>
          <p>
            <a
              className={classes.link}
              href="https://sunbit.com/sunbit-for-stripe/"
              target="_blank"
            >
              Learn more
            </a>{" "}
          </p>

          <p>
            Subject to approval based on creditworthiness. Payment is due at
            checkout. 0-35.99% APR. Maximum loan amounts may vary based on
            merchant. Account openings and payment activity are reported to a
            major credit bureau. See Rates and Terms for loan requirements and
            state restrictions. Sunbit is licensed under the CT Laws Relating to
            Small Loans (lic. # SLC-1760582 & SLC-BCH-1844702). Loans are made
            by TAB Bank.
          </p>
        </div>
      </Box>
      <Box className={classes.capabilitiesBox}>
        {isLoading ? (
          <Skeleton height={50} count={3} />
        ) : (
          <Capabilities capabilities={data?.capabilities || []} />
        )}
      </Box>
    </LayoutPosSettings>
  );
};

export default PosSunbit;
